"use client";

import Script from "next/script";
import React from "react";

export type FormPipedriveModuleProps = { formId: string };

export const FormPipedriveModuleView = ({ formId }: FormPipedriveModuleProps) => {
    return (
        <div
            className="pipedriveWebForms"
            data-pd-webforms={`https://webforms.pipedrive.com/f/${formId}`}
        >
            <Script src="https://webforms.pipedrive.com/f/loader"></Script>
        </div>
    );
};
